/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import Menu from './menu';

export * from './menu-props';

/**
 * Exporting Menu class.
 */
export { Menu };
